import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import Checkout from './Checkout';
import imageAside from "../../images/form-aside.png";
import Loader from '../../images/loader.png';
import {Elements,useStripe,useElements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { getPaymentIntent, userValidate } from "../../services/api";
import Header from "../common/Header";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const Register=()=>{
	const navigate = useNavigate();
	const [isloader , setIsLoader] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [clientSecret, setClientSecret] = useState("");

	useEffect(() => {
	  const isAuthenticated = sessionStorage.getItem('token');
	  if (isAuthenticated) {
		navigate('/course/home');
	  }
	}, []);
	const [formData, setFormData] = useState({
		email: '',
		password: ''
	  });
	const [errors, setErrors] = useState({});
  	const [successMessage, setSuccessMessage] = useState('');
	const [acceptedTerms, setAcceptedTerms] = useState(false);
	  const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
		  ...formData,
		  [name]: type === 'checkbox' ? checked : value
		});
	  };
	  const validate = () => {
		let errors = {};
	
		if (!formData.email) {
		  errors.email = 'Email is required';
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
		  errors.email = 'Email address is invalid';
		}
		if (!formData.password) {
		  errors.password = 'Password is required';
		} else if (formData.password.length < 6) {
		  errors.password = 'Password must be at least 6 characters';
		}
		setErrors(errors);
	
		return Object.keys(errors).length === 0;
	  };

	

	  const handleNext = async (e) => {
		e.preventDefault();
		if (validate()) {
			setIsSubmitting(true);
			setErrors({}); // Clear previous errors
			try {
				const response = await userValidate(formData);
		  
				if (response.data) {
					const paymentResponse = await getPaymentIntent();
					setClientSecret(paymentResponse.data);
				}
			} catch (error) {
				console.error('Registration error:', error);
				
				if (error.response) {
					// Server responded with error status
					if (error.response.status === 422) {
						const serverErrors = error.response.data.errors;
						setErrors({
							...serverErrors,
						});
					} else {
						setErrors({
							general: error.response.data?.message || 'An error occurred. Please try again.',
						});
					}
				} else if (error.request) {
					// Request was made but no response received (network error)
					setErrors({
						general: 'Network error. Please check your internet connection and try again.',
					});
				} else {
					// Something else happened
					setErrors({
						general: error.message || 'An unexpected error occurred. Please try again.',
					});
				}
			} finally {
				setIsSubmitting(false);
			}
		}
	  };

	  const responseMessage = async(response) => {
		const decodedToken = jwtDecode(response.credential);
	
										if(decodedToken){
										    setFormData((prevFormData) => ({
											...prevFormData,
											email: decodedToken.email || prevFormData.email,  
											password: prevFormData.sub || 'google-oauth' 
										  }));
		   const response = await getPaymentIntent();
		   setClientSecret(response.data);
		 
		//    const response = await googleLogin(formData);
		//    if(response.data.token){
		// 	   setSuccessMessage('Login successful!');
		// 	   sessionStorage.setItem('token', response.data.token);
		// 	   sessionStorage.setItem('user_id', response.data.user.id);
		// 	   sessionStorage.setItem('user_name', response.data.user.name);
		// 	   sessionStorage.setItem('user_email', response.data.user.email);
			   
		// 	   const redirectPath = sessionStorage.getItem('redirectPath') || '/';
		// 	   sessionStorage.removeItem('redirectPath');
		// 	   navigate(redirectPath);
		//    }
		//    else{
		// 	   setErrors({ apiError: response.data.error });
		//    }
		}
   };
   const errorMessage = (error) => {
	   console.log(error);
   };
	return (
		<>
		<Header />
		<div className="login-register">
			{isloader &&
		<div class="loader position-fixed top-0 bottom-0 start-0 end-0 bg-dark">
		<span class="position-absolute top-50 start-50 translate-middle"><img src={Loader} alt="Loader"  /></span>
		</div>
		}
		
		<div class="container d-flex align-items-center mvh-100">
			{/* <Link className="back-btn mr-3 " to="/"><i class="fa fa-arrow-left" aria-hidden="true"></i></Link> */}

			<section class="login-registration rounded-3 overflow-hidden shadow bg-light">
				<div class="row align-items-stretch">
				<div class="col-md-6 bg-secondary-s text-center text-white">
					<div class="p-5">
					<h1 class="h3">Let's Get Started</h1>
					<p>Sign Up and get access to all the features of Florida Driving Permit <br></br><br></br>
					{errors.apiError && <span className="text-danger">{errors.apiError}</span>}
					{errors.payment && <span className="text-danger">{errors.payment}</span>}
					{errors.registration && <span className="text-danger">{errors.registration}</span>}
					{errors.general && <span className="text-danger">{errors.general}</span>}
					{successMessage && <span className="text-success">{successMessage}</span>}</p>
                    {clientSecret?( 
                            <Elements stripe={stripePromise} options={{ clientSecret, wallets: { link: 'never' }, appearance: { rules: { '.Label': { color: '#ffffff' } } } }}>
								<Checkout clientSecret = {clientSecret} setErrors = {setErrors} setIsLoader={setIsLoader} formData = {formData}/> 
							</Elements>):(
							<form class="text-dark py-4" onSubmit={handleNext}>
									<div class="row">
									<div class="col-lg-6">
										<div class="form-floating mt-4">
										<input type="email" class="form-control" id="email" placeholder=" " name="email" value={formData.email} onChange={handleChange}/>
										<label htmlFor="email">Email Address</label>
										{errors.email && <span className="text-danger">{errors.email}</span>}
										</div>
									</div>
									<div class="col-lg-6">
										<div class="form-floating mt-4">
										<input type="password" class="form-control" id="password" placeholder=" "  name="password" value={formData.password} onChange={handleChange} autoComplete="current-password"/>
										<label htmlFor="password">Password</label>
										{errors.password && <span className="text-danger">{errors.password}</span>}
										</div>
									</div>
								<div class="col-12">
									<div class="form-check mt-4 text-start d-flex gap-2">
									<input class="form-check-input mt-0" type="checkbox" id="terms" name="terms" checked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)} />
									<label class="form-check-label text-white" htmlFor="terms">I agree to <a href="/terms-conditions" target="_blank" rel="noopener noreferrer" class="text-primary-s">Terms &amp; Conditions</a></label>
									</div>
								</div>
								<div class="col-12">
									<button 
										name="btn" 
										class="btn btn-primary-s px-4 py-3 my-4 w-100 text-white"
										disabled={isSubmitting || !acceptedTerms}
									>
										{isSubmitting ? (
											<>
												<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												Processing...
											</>
										) : (
											'Register'
										)}
									</button>
									<p class="text-white">Already a member? <Link to="/login" class="text-primary-s fw-bold">LOGIN</Link></p>
								</div>
								{/* <div class="col-lg-12 mt-3">
									<GoogleLogin class="btn btn-danger px-4 py-2 my-4 w-100" onSuccess={responseMessage} onError={errorMessage} />
								</div> */}
								</div>
							</form> 
						)}
					</div>
				</div>
				
				<div class="col-md-6 text-center d-none d-md-block">
					<div class="p-5">
					<Link to="/" class="mb-2 mt-4 wow animated fadeInLeft hide-mobile logoText">
							<h3>Florida <span>Driving</span> Permit</h3>
					</Link>
					<br /><br />
					<hr class="opacity-50" />
						<img src={imageAside} alt="Form Aside" class="img-fluid mt-5 w-85" />
					</div>
				</div>
			</div>
		</section>
	</div>
</div>
</>
);
};
export default Register;